export default __webpack_public_path__ + "static/media/instagram-icon.4f069e0a.svg";